// extracted by mini-css-extract-plugin
export default {"mailButton":"MailButton_mailButton__8FW7e","icon":"MailButton_icon__-LQpW"};